export default {
  state: {
    error: {}
  },
  mutations: {
    setError (state, payload) {
      state.error = payload
    }
  },
  actions: {
    handleError ({dispatch, commit}, payload) {
      commit('setError', payload)
      if (payload.message === 'Network Error') {
        dispatch('showNotification', {
          title: 'Sie haben keine Verbingung!',
          type: 'error'
        })
        return
      }
      if (payload.response.status === 401 || payload.response.status === 403) {
        dispatch('logout')
      } else {
        dispatch('showNotification', {
          title: payload.response.data.message,
          type: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/error/index.js